import { Box, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import { Colors } from '../../../design/color/Colors';


type IRatingProgressProperties = {
  value: number;
  label?: string;
  threeColors?: boolean;
};

export const RatingProgress = ({ value, label, threeColors = false }: IRatingProgressProperties) => {
    const progressColor = React.useMemo(() =>   {
    if (threeColors) {
      if (value >= 66) return Colors.success;
      if (value >= 33) return Colors.warning;
      return Colors.error;
    }
    if (value >= 70) return Colors.success;
    return Colors.error;
  }, [value, threeColors]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LinearProgress
        value={value}
        variant="determinate"
        sx={{
          width: 100,
          minWidth: 100,
          height: 8,
          borderRadius: 999,
          '& .MuiLinearProgress-bar': {backgroundColor: progressColor},
        }}
      />
      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
        {label || `${value}%`}
      </Typography>
    </Box>
  );
};
